<template>
  <div class="filter notranslate">
    <div class="genres">
      <div class="genreBox">
        <div class="genre bookmark" :class="{active: bookmark}"
          @click="activeBookmark">
          <span></span>
        </div>
        <div v-for="genre in list" :key="genre.id" class="genre toCapitalize"
          :class="{active: genre.active}"
          @click="activeGenre(genre.id)">
          {{getGenreName(genre.id)}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChannelGenre',
  props: [
    'lang',
    'locale',
    'list'
  ],
  created () {
    this.bookmark = false
  },
  data () {
    return {
      bookmark: false
    }
  },
  methods: {
    activeBookmark () {
      this.bookmark = !this.bookmark
      this.$emit('viewBookmark', this.bookmark)
    },
    activeGenre (id) {
      this.$emit('active', id)
    },
    getGenreName (id) {
      const genre = `genre_${id}`
      return this.locale[genre]
    }
  }
}
</script>

<style lang="scss" scoped>
.genres {
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid $color-lgrey2;
  background-color: $color-white;
  box-shadow: 0 0 10px rgba(0,0,0,0.15);
}
.genreBox {
  padding: 8px 15px;
  white-space: nowrap;
  overflow: auto;
}
.genre {
  display: inline-block;
  width: auto;
  margin-right: 4px;
  padding: 0.2em 1em;
  vertical-align: top;
  font-size: 14px;
  color: $color-grey;
  border: 1px solid $color-lgrey2;
  border-radius: 50px;
  cursor: pointer;
}
.active{
  color: $color-white;
  border-color: $color-green;
  background-color: $color-green;
}
.bookmark {
  position: relative;
  width: calc(1.9em + 2px);
  height: calc(1.9em + 2px);
  margin-right: 8px;
  padding: 0;
  background-color: $bg-default;
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -1px;
    line-height: 1;
    font-size: 1.4em;
    font-family: sans-serif;
    font-weight: bold;
    transform: translate(-50%, -50%);
    &:before {
      content: "\2606";
      color: $color-grey;
    }
  }
  &.active {
    border-color: $color-lgrey2;
    background-color: $color-white;
    span {
      font-size: calc(1.4em + 1px);
      &:before {
        content: "\2605";
        color: #ffb203;
      }
    }
  }
}
</style>
